import { SymbolData } from '../types';

export const trigramsData: SymbolData[] = [
  {
    id: 'tri-qian',
    char: '乾',
    pinyin: 'Qián',
    summary: '乾：天、最有权、最有钱、最有名',
    tags: ['最有权', '最有钱', '最有名', '高快', '刚健', '金行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203150244.png',
    story: '高贵的元首，以威严正直的刚健之姿，在京都大厦中执掌至高权力，坐拥金玉财富，声望显赫，他如龙鹰般高快地乘坐飞机，头戴帽子，巡视晴空下广袤的高亢大地，即便偶有头痛，也始终创造着圆满与永久。',
    coreOrigins: [
      {
        title: '原点①：最有权',
        logic: '乾为天，为万物之始，是法则的制定者与权力的象征，代表着至高无上的统帅、管理与核心地位。',
        subItems: [
          { label: '概念', content: '有威严、权力、统帅、正直、尊敬、创造、法则、本原、核心、精华、向上、长辈、永久。' },
          { label: '性情', content: '严正威武、威严豁达、正直勤勉、自尊高傲。' },
          { label: '地理', content: '首脑集中地、京都、大城市、大会堂、广场、高级住宅、大厦、警察局、机关、武官、博物馆、邮局。' },
          { label: '人物', content: '国家元首、主要领导人、寺院主持、总经理、老板、祖父、老者、厂长、高贵的人、元老。' },
          { label: '人体', content: '头、颈、面部、男性生殖器、精液。' },
          { label: '疾病', content: '头痛、脑淤血、心脏病、神经病、老病、旧病、急性暴病。' },
        ],
      },
      {
        title: '原点②：最有钱',
        logic: '乾卦五行属金，方位在西北（金库之地），代表金玉、财富以及秋天的圆满收获。',
        subItems: [
          { label: '概念', content: '充实、满足、圆满、收获。' },
          { label: '静物', content: '金玉珠宝、高档用品、金钱、钟表、镜子、眼镜、圆形金属、首饰。' },
          { label: '食物', content: '水果、糖果、蛋糕、年糕、冰激凌、豆腐、鸡蛋、高级食品、火腿、香肠、干肉、马肉、米、麦、豆类、花生。' },
          { label: '地理', content: '西北方、繁华地、银行、金属工厂、配件商店。' },
          { label: '人体', content: '肺、大肠。' },
        ],
      },
      {
        title: '原点③：最有名',
        logic: '作为权力和成功的极致，乾也代表着由此带来的巨大声望、荣誉和被大众所效仿的典范形象。',
        subItems: [
          { label: '概念', content: '模范、喜悦、优胜。' },
          { label: '地理', content: '名胜古迹、寺院。' },
          { label: '人物', content: '名流、专家。' },
        ],
      },
      {
        title: '原点④：高快',
        logic: '乾的本象为“天”，引申为天空、高处，以及一切具有超越性、高速移动特征的事物。',
        subItems: [
          { label: '形态', content: '高大雄伟。' },
          { label: '天时', content: '晴天、晴空、太阳。' },
          { label: '静物', content: '飞机、火车、轿车、自行车、摩托车、帽子、头巾、面罩、高大物。' },
          { label: '动物', content: '龙、鹰。' },
        ],
      },
      {
        title: '原点⑤：刚健',
        logic: '乾卦三爻皆阳，纯阳至刚，代表着永不停歇的行动力、坚韧不拔的意志和竞争、战争等激烈行为。',
        subItems: [
          { label: '概念', content: '健壮、坚固、激烈、战争、竞争、胆量。' },
          { label: '性情', content: '好动少静、重情讲义。' },
          { label: '静物', content: '武器、刀剑。' },
          { label: '动物', content: '狮子、大象、老虎、猪、熊、狗、马、鹅、鲸鱼。' },
          { label: '人体', content: '肋骨、指甲、右腿、皮毛、骨骼。' },
        ],
      },
    ],
  },
  {
    id: 'tri-kan',
    char: '坎',
    pinyin: 'Kǎn',
    summary: '坎：水、险陷、性、流动、阴暗、智慧',
    tags: ['险陷', '性', '流动', '阴暗', '智慧', '水行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203150510.png',
    story: '在北方阴暗的地下室里，劳苦的盗贼因性与酒色的诱惑而沉溺险陷，他烦恼地看着血液在流动，耳边回荡着狡诈的低语，命运如江河般漂泊不定，最终在深夜雨雪中，凭借科学家般的智慧与谋略，挣脱绳索般的困境。',
    coreOrigins: [
      {
        title: '原点①：险陷',
        logic: '坎卦上下皆阴，一阳陷于其中，是为“险”。代表陷入困境、遭遇灾难、劳苦与病痛，是人生道路上的艰难险阻。',
        subItems: [
          { label: '概念', content: '劳苦、艰难、苦难、险阻、烦恼、陷落、沉溺(指困境而非情欲)、毒害、灾难、踌躇、缺陷、失败、困难。' },
          { label: '人物', content: '孕妇(身负重担)、盗贼、匪人、逃亡者、黑社会人物、酒鬼、诈骗犯、吸毒者。' },
          { label: '地理', content: '医院。' },
          { label: '人体', content: '血液、体液、骨髓。' },
          { label: '疾病', content: '怕冷、水肿、疮、中毒、血行不畅、脚部疾病、神经衰弱、抑郁症、糖尿病、血液病、髓坏疽、风寒、拉肚子、流感等。' },
        ],
      },
      {
        title: '原点②：性',
        logic: '坎为水，有交合、渗透之象，一阳陷于二阴之中，是欲望与沉溺的体现。代表男女情事、生殖繁衍以及由此带来的诱惑与危险。',
        subItems: [
          { label: '概念', content: '色情、诱惑、沉溺(指情欲沉溺)、交合、关系。' },
          { label: '地理', content: '妓院、酒吧、娱乐场所、洗发房。' },
          { label: '人物', content: '娼妇、中男、多情之人。' },
          { label: '人体', content: '肾、膀胱、泌尿系统、生殖系统、阴部、子宫、卵巢、尿道、生殖器、内分泌系统。' },
        ],
      },
      {
        title: '原点③：流动',
        logic: '水的本性是流动、渗透和交融，无孔不入。因此代表着一切流动变化、交通往来以及人际关系的结合。',
        subItems: [
          { label: '概念', content: '交际、交往、结合、漂泊、时尚(潮流)。' },
          { label: '地理', content: '江河、湖海、溪涧、泉、井、沟渠、洼地、潮湿、下水道、鱼池、浴池、车站、码头、渔场、水库、洗手间、厨房、厕所。' },
          { label: '人物', content: '船员、驾驶员、江湖之人、水产经营者、流动性强的职业、劳务打工人员、旅游家。' },
          { label: '静物', content: '带子、绳子、裙子、液体、饮料、酒油、汤具、水具、涂料、冷藏设备、消防设备、潜水艇、浮萍、轮子、船。' },
        ],
      },
      {
        title: '原点④：阴暗',
        logic: '水在深渊则黑暗，在北方则寒冷，在夜里则与月光相应。代表着一切阴暗、寒冷、隐藏和不可告人的事物。',
        subItems: [
          { label: '概念', content: '暗昧、沉默、隐伏。' },
          { label: '地理', content: '北方、黑暗的家、地下室。' },
          { label: '动物', content: '猪(性喜阴湿)、狐狸、夜行动物、鼠。' },
          { label: '人体', content: '耳、肛门。' },
        ],
      },
      {
        title: '原点⑤：智慧',
        logic: '水利万物而不争，深不可测，象征着内在的智慧、谋略、艺术与深沉的情感。',
        subItems: [
          { label: '概念', content: '测量、思考、滋润、仁慈、智慧、聪明、狡诈。' },
          { label: '人物', content: '医生、教育工作者、科学家、宗教家、心理学家、画家、作家。' },
          { label: '静物', content: '音像制品、文具、墨水。' },
        ],
      },
    ],
  },
  {
    id: 'tri-gen',
    char: '艮',
    pinyin: 'Gèn',
    summary: '艮：山、止、稳固、少男',
    tags: ['止', '山', '稳固', '少男', '土行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203150703.png',
    story: '憨厚固执的少男在东北方的大山脚下，被岩石墙壁阻隔而停止不前，如同犯人般困顿，他稳固地坐在椅子上，背着沉重的行囊，迟缓地思考着改革的开端，手中还握着瓜果，期盼着宗庙祠堂的安宁。',
    coreOrigins: [
      {
        title: '原点①：止',
        logic: '艮的本义即“止”，代表事物的停止、阻碍、断绝和等待的状态。',
        subItems: [
          { label: '概念', content: '静止、断绝、呆板、等待、困难、迟滞、阻隔、艰难。' },
          { label: '地理', content: '监狱、派出所。' },
          { label: '人物', content: '犯人、孤独人。' },
          { label: '静物', content: '门户、门坎、台阶、座位、屏风、墙壁。' },
          { label: '疾病', content: '筋骨酸痛、消化不良、虚弱、小儿麻痹症、疮肿、瘤、结石、疑难症、虚胀、麻木。' },
        ],
      },
      {
        title: '原点②：山',
        logic: '艮的卦象为山，代表一切高高凸起的地貌、建筑以及作为界限的事物。',
        subItems: [
          { label: '地理', content: '东北方、丘陵、坟墓、山地、高坡、桥梁、堤坎、休息室、大楼、仓库、宗庙祠堂、矿山、采石场、银行。' },
          { label: '人物', content: '山中人、肥胖人、仓库管理、土建人员、矿工、房地产商。' },
          { label: '静物', content: '岩石、山坡、阶梯、石碑、土坑、椅子、桌子、床、土中之物、石刻、石块、瓷器。' },
          { label: '人体', content: '背、腰、鼻、手、指、关节、左腿、脚腕、脚趾、乳房、脾、胃、结肠。' },
        ],
      },
      {
        title: '原点③：稳固',
        logic: '山体稳固厚重，引申为稳定、固守、诚实守信的品格，以及保守、固执不变通的性情。',
        subItems: [
          { label: '概念', content: '稳定、固守、慎重、诚实、守信、安定。' },
          { label: '性情', content: '保守、固执、憨厚、稳重、诚实、守信、谨慎、迟缓、安静、笃实、任劳任怨。' },
          { label: '人物', content: '宗教人员、信徒、保守者、警卫、贵族、法官、家具商。' },
        ],
      },
      {
        title: '原点④：少男',
        logic: '艮为少男，代表终点之后的新生力量，象征着事物的开始、变化、转折与希望。',
        subItems: [
          { label: '概念', content: '开始、变化、转折、改革。' },
          { label: '人物', content: '少男、儿童、学生。' },
          { label: '植物', content: '瓜类、黄色植物、萝卜、甘薯、土豆、花生、木耳、冬瓜、丝瓜。' },
          { label: '食物', content: '牛肉、兽肉、根类食物、山蘑、山中采集的食物、汤圆、甘薯、糖果。' },
        ],
      },
    ],
  },
  {
    id: 'tri-zhen',
    char: '震',
    pinyin: 'Zhèn',
    summary: '震：雷、长男、震动、声响、生长',
    tags: ['长男', '震动', '声响', '生长', '木行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203150751.png',
    story: '一果断的军人长男在东方青绿竹林中，因雷雨闪电的震动与声响而惊醒，他驾驶汽车迅速奔赴战场，手持武器，如龙般奋起，神经因兴奋而颤动，象征着万物旺盛的生长与积极的开拓。',
    coreOrigins: [
      {
        title: '原点①：长男',
        logic: '震在八卦家族中为长男，是家庭和组织中的继承者与开拓者。他代表了果断的行动力、新兴的权威和勤奋开拓的精神。',
        subItems: [
          { label: '人物', content: '长男、长子、年长者、名人、医生、学生、电器商、木匠、旅行者、律师、将帅、军人、壮士、警察、法官、社会活动家。' },
          { label: '性情', content: '意气风发、积极果断、刚愎自用、勤奋直爽、自尊心强、独断专行。' },
          { label: '地理', content: '公安机关、军队、商店、游乐场。' },
          { label: '动物', content: '龟、蜈蚣、蜘蛛、蜂类、多足类、鲤鱼。' },
        ],
      },
      {
        title: '原点②：震动',
        logic: '这是震卦最核心的物理表现。能量的瞬间释放导致了物理层面的剧烈运动、冲击和不稳定状态，从大地的震颤到人心的惊动。',
        subItems: [
          { label: '概念', content: '震动、惊动、躁动、冲动、转移、迅速、显现、影响。' },
          { label: '天时', content: '大冰雹、闪电、地震、海啸、火山喷发。' },
          { label: '静物', content: '飞机、汽车、火车、武器、棒子。' },
          { label: '人体', content: '足、神经、左肋、左肩臂、左手。' },
          { label: '疾病', content: '神经病、足疾、扭伤、脚气、发狂、恐惧、精神失常、癫痫症、心悸、关节炎、手足麻痹、神经衰弱。' },
        ],
      },
      {
        title: '原点③：声响',
        logic: '这是震卦的听觉表现。巨大的能量以声音的形式爆发出来，代表了一切洪亮、喧哗、有节奏或刺耳的声音，也引申为语言和音乐的表达。',
        subItems: [
          { label: '静物', content: '乐器、电器、铃、电话、鞭炮、闹钟、音响、手机、麦克风、鼓。' },
          { label: '地理', content: '闹市、繁华街道、广播电台、电影院、歌舞厅、机场、菜市场、乐器店、夜总会、音乐学院、噪音大的场所。' },
          { label: '人物', content: '吵闹者、歌手、音乐家、说大话的人。' },
          { label: '人体', content: '喉咙、声带、舌。' },
        ],
      },
      {
        title: '原点④：生长',
        logic: '震为动，五行为木，方位为东，时节为春。雷声之后，万物复苏，代表着破土而出的奋发之势和蓬勃的生命力。',
        subItems: [
          { label: '概念', content: '奋起、奋进、上升、积极、旺盛、发育、生长。' },
          { label: '地理', content: '东方、竹林、树林、草木茂盛的地方、公园。' },
          { label: '植物', content: '树木、草、竹、蔬菜、花卉、盆栽。' },
          { label: '人体', content: '发、肝脏。' },
        ],
      },
    ],
  },
  {
    id: 'tri-xun',
    char: '巽',
    pinyin: 'Xùn',
    summary: '巽：风、木、柔顺、流动、渗透',
    tags: ['木', '柔顺', '流动', '渗透', '木行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203150941.png',
    story: '柔顺的长女在东南方青绿森林中，如风般流动忙碌，手持扇子营销宣传品，气息渗透过通风道，她有时狡猾，有时疑惑，如鸡蛇般穿梭，头发飘动，带来生机也可能带来空虚与迷失。',
    coreOrigins: [
      {
        title: '原点①：木',
        logic: '巽卦五行属木，代表一切与木材、植物、生长、绿色相关的象意。',
        subItems: [
          { label: '概念', content: '生长、生命力、自然、环保、生发。' },
          { label: '地理', content: '森林、花园、植物园、木材厂。' },
          { label: '植物', content: '柳、芦苇、竹、松、杉、蔓草类、葡萄百合、牵牛花、葫芦、玫瑰、丝瓜、南瓜。' },
          { label: '静物', content: '树木、木制品、纤维品、竹木品、水果、药材。' },
          { label: '人体', content: '肝、胆。' },
        ],
      },
      {
        title: '原点②：柔顺',
        logic: '巽为长女，性情柔顺，如微风拂面。同时也代表着灵巧的工艺、文雅以及华而不实的表象。',
        subItems: [
          { label: '概念', content: '柔和、顺从、调和、谦逊。' },
          { label: '性情', content: '优柔寡断、柔和谦虚、心情徘徊、狡猾市侩、虚情假意、超俗世外、华而不实。' },
          { label: '人物', content: '长女、妻子、女友、寡妇、秃头(风有散失之象)、教师、科技人员、狡猾者、优柔寡断者、文质彬彬读书人、能工巧匠。' },
          { label: '静物', content: '扇子、电风扇、鼓风机、通风机器、丝绳、抽屉、屏风、草鞋、椅子、床、毛巾、纸张、铅笔、小刀、化妆用具、拆信、雕刻物。' },
        ],
      },
      {
        title: '原点③：流动',
        logic: '风的本性是流动，无固定形态，代表一切移动、运输、奔波和信息传播相关的象意。',
        subItems: [
          { label: '概念', content: '流动、货运、迷途、奔波、号令、荣誉、普遍性、自由运动、忙碌。' },
          { label: '地理', content: '东南方、邮局、过道、长廊、升降机、索道、传送带、码头、商店、各种管道处、电梯、通风道、出入口。' },
          { label: '人物', content: '营销员、向导、新闻人员、公关人员、商人、流浪者、作者、广告业、出版业。' },
          { label: '静物', content: '汽艇、帆船、电线杆、铁轨、气球、风筝、各种票据(流通之物)。' },
        ],
      },
      {
        title: '原点④：渗透',
        logic: '风无孔不入，能深入缝隙；其形态无形，可闻可见但不可捉摸，引申为深入、疑惑、空虚和与嗅觉、呼吸相关的意象。',
        subItems: [
          { label: '概念', content: '空虚、深入、浅出、疑惑、徘徊、渗透性、没有固定地点。' },
          { label: '地理', content: '山林、洞穴、草原、芦苇荡。' },
          { label: '人物', content: '僧尼、仙道之人、有狐臭。' },
          { label: '静物', content: '香烟、有香味的东西、宣传品、下面有口之物(容器)。' },
          { label: '人体', content: '呼吸系统、食道、肠、神经、头发、血管、腹部、腋下、乳、耳。' },
        ],
      },
    ],
  },
  {
    id: 'tri-li',
    char: '离',
    pinyin: 'Lí',
    summary: '离：火、美丽、空虚、文明',
    tags: ['火', '美丽', '空虚', '文明', '火行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203151220.png',
    story: '美丽的明星中年妇女在南方娱乐厅中，如火般热情，身着红色衣裳，用手机记录着光明与文明，眼神闪耀，却藏着内心的空虚与虚伪，如同孔雀雉鸡般外表华丽，她也可能在图书馆阅读报刊，心脏跳动，展现着变化与迅速。',
    coreOrigins: [
      {
        title: '原点①：火',
        logic: '火是离卦的本象，代表光、热、电等一切可见、发热、迅速变化的能量形态。',
        subItems: [
          { label: '概念', content: '光明、变化、迅速、流行、时尚、警惕(目光如炬)。' },
          { label: '地理', content: '南方、朝阳的场所、天文台、电子产品、冶炼厂、火车站、火山、电厂、广告牌。' },
          { label: '静物', content: '电灯、电话、打火机、手机、电动机、电气焊工具、电子电器产品。' },
          { label: '人体', content: '眼睛、血液、心脏、神经。' },
          { label: '疾病', content: '心脏病、眼疾、视力减退、近视、色盲、头痛、烫伤、热症。' },
        ],
      },
      {
        title: '原点②：美丽',
        logic: '“离者，丽也。” 火光依附于物体而显现，引申为一切依附于外表的装饰、文采与美丽。',
        subItems: [
          { label: '概念', content: '美丽、尊敬、化妆、妆饰、文才、判断、鉴定。' },
          { label: '地理', content: '娱乐厅、电影院、华丽街道、美容院、画廊、殿堂。' },
          { label: '人物', content: '中年妇女(离为中女)、美人、明星、中层干部、美容师、画家、摄影者、快活、艺术家、多情人。' },
          { label: '静物', content: '化妆品。' },
        ],
      },
      {
        title: '原点③：空虚——甲壳',
        logic: '离卦外阳内阴，是“外实内虚”之象，代表一切有硬壳、外表华丽而内里中空或虚幻的事物。',
        subItems: [
          { label: '概念', content: '外刚内柔、枯燥、空虚、暴露、虚伪。' },
          { label: '动物', content: '龟、蚌、蟹、甲壳虫。' },
          { label: '植物', content: '竹子、椰子、带壳的果实。' },
          { label: '静物', content: '锅炉、玻璃门窗。' },
        ],
      },
      {
        title: '原点④：文明',
        logic: '火带来了熟食和光明，是人类文明的开端，象征着文化、教育、契约等一切智慧的产物。',
        subItems: [
          { label: '地理', content: '图书馆、印刷厂、电视台、教堂、学校、文化部门。' },
          { label: '人物', content: '文人、作家、影视经营者、博学、编辑、纪检人员、白领人员、幻想者。' },
          { label: '静物', content: '报刊、图书、字画、文件、票据、证件、契约、执照、照片、电脑、电视、复印机。' },
        ],
      },
    ],
  },
  {
    id: 'tri-kun',
    char: '坤',
    pinyin: 'Kūn',
    summary: '坤：地、母亲、众庶、忧虑',
    tags: ['大地', '母亲', '众庶', '忧虑', '土行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203152000.png',
    story: '柔顺的母亲妇人在西南方的田野乡村中，承载着众庶农民的劳作，她用瓷器盛着糙米，穿着深黄色的衣服，如同牛羊般默默无闻，内心却因迟缓和沉默而忧虑，腹部虽感疲劳，但肌肉依然强韧，这大地般的包容也藏着贫血的隐患。',
    coreOrigins: [
      {
        title: '原点①：大地',
        logic: '坤的本象为大地，代表一切与土地相关的属性，如承载、方形、广阔、以及由土制成的物品。',
        subItems: [
          { label: '概念', content: '大地、方形、开阔、稳健、踏实、伏藏、包容、含蓄。' },
          { label: '地理', content: '西南方、原野、田野、平地、盆地、空地、旷野、矮屋、下方、底层、庄稼地。' },
          { label: '静物', content: '瓷器、方形物、水泥、砖瓦、土中之物、锅瓦。' },
          { label: '人体', content: '腹、脾脏、胃、肚脐、肌肉、消化器官。' },
        ],
      },
      {
        title: '原点②：母亲',
        logic: '坤为老母，是纯阴之体，象征着母亲般的柔顺、谦卑、慈悲与滋养万物的品德。',
        subItems: [
          { label: '概念', content: '柔顺、平安、文雅、勤俭、谦卑、依赖、慈悲、安静、温厚。' },
          { label: '人物', content: '母亲、妻子、妇人、皇后、领导夫人、奶奶、女领导、胖女人、大腹人、忠厚之人。' },
          { label: '静物', content: '方柔之物、五谷、布帛、丝棉、药品、妇女用品。' },
          { label: '疾病', content: '贫血、下体流血、虚脱、浮肿、慢性病。' },
        ],
      },
      {
        title: '原点③：众庶',
        logic: '大地承载万民，引申为群众、百姓以及他们的生产生活、所用之物和聚集之所。',
        subItems: [
          { label: '地理', content: '乡村、农村、牧场、农舍、民房、农贸市场、集会场所、办公室、公园、仓库、寝室、肉类加工厂、鸡窝、兔圈、操场。' },
          { label: '人物', content: '副手、助理、职员、书商、地产商、建筑工人、农民、群众、房地产、农牧业经营者、秘书。' },
          { label: '静物', content: '衣服、大车、日用品、农具、书包、纸张、汽车等。' },
        ],
      },
      {
        title: '原点④：忧虑',
        logic: '纯阴至极也代表着被动、迟缓、无主见，从而引申出迷惘、忧虑、懦弱等消极状态。',
        subItems: [
          { label: '概念', content: '迷惘、忧虑、迟缓、消极、沉默、优柔、寡断、懦弱、卑贱、丑陋。' },
          { label: '性情', content: '行动迟缓、吝啬消极、固执保守。' },
          { label: '地理', content: '殡仪馆。' },
          { label: '人物', content: '寡妇、胆小人、消极人、丑陋人。' },
        ],
      },
    ],
  },
  {
    id: 'tri-dui',
    char: '兑',
    pinyin: 'Duì',
    summary: '兑：泽、少女、口舌、锐利、破损',
    tags: ['少女', '口舌', '锐利', '湖泽', '破损', '金行'],
    imageUrl: 'https://pic-1314100616.cos.ap-nanjing.myqcloud.com/img/20251203151733.png',
    story: '喜悦的少女歌手在西方湖泽边的娱乐场中，用锐利的口舌唱着歌，她戴着金银首饰，穿着白色衣裳，虽然机敏，却也带着破损的瓦罐，像羊兔般温顺，却有虎豹般的锋芒，肺部因歌唱而起伏，牙齿洁白，犹如新月有缺，却依然美丽，即便身处潮湿，也充满恩惠。',
    coreOrigins: [
      {
        title: '原点①：少女',
        logic: '兑为少女，象征着青春的喜悦、纯真的爱意和天生的魅力，引申为一切带来快乐、和睦与感官享受的活动。',
        subItems: [
          { label: '概念', content: '舞会、庆典、娱乐、色情、恩惠、和睦、敬爱、爱欲、魅力。' },
          { label: '地理', content: '游乐场、娱乐场、影剧院。' },
          { label: '人物', content: '少女、年轻女性、空姐、坐台小姐、小女孩、性魅力者、欢乐性职业。' },
          { label: '人体', content: '女性器官、胸部。' },
        ],
      },
      {
        title: '原点②：口舌',
        logic: '兑卦上缺，其形如口，因此一切与口的功能相关的事物——说话、辩论、唱歌、饮食——都归于此。',
        subItems: [
          { label: '概念', content: '口舌、议论、饮食、酒食、唱歌、接吻、雄辩。' },
          { label: '地理', content: '咖啡馆、茶馆、饭店、音乐厅、公关部、会议室。' },
          { label: '人物', content: '歌手、话务员、教师、律师、讲解员、翻译、厨师、牙医、巫师、媒婆、神汉、导游、相声演员、经销人员、评论家、音乐家。' },
          { label: '静物', content: '乐器(发声如口)、带口之物、邮筒。' },
          { label: '人体', content: '口、舌、牙齿、涎、气管、咽喉。' },
        ],
      },
      {
        title: '原点③：金——锐利',
        logic: '兑的五行为金，代表秋天的肃杀、金属的锐利、坚硬和贵重，以及其对应的颜色与方位。',
        subItems: [
          { label: '概念', content: '机敏(思维锋利)。' },
          { label: '地理', content: '西方。' },
          { label: '静物', content: '财宝、金银首饰、五金工具、金属制品、刀剑、剪刀、手术刀。' },
          { label: '人体', content: '肺、右肋、右肩臂、大肠(五行属金)。' },
        ],
      },
      {
        title: '原点④：湖泽',
        logic: '“兑为泽”，代表低洼汇水的沼泽湖泊，象征一切湿润、凹陷的地理环境及生于其中的万物。',
        subItems: [
          { label: '天时', content: '潮湿的天气、气压低、露水、阴雨连绵、小雨。' },
          { label: '地理', content: '沼泽地、峡谷、泽覃、湖泊、池塘、滑冰场、井坑、洞穴。' },
          { label: '动物', content: '泥鳅、猿猴(居于峡谷)、水鸟、仙鹤、沼泽动物。' },
        ],
      },
      {
        title: '原点⑤：破损',
        logic: '兑卦上爻为阴，是“上缺”之象，代表不完美、破损、缺陷，以及一切带有开口的器物。',
        subItems: [
          { label: '概念', content: '伪善(品德的缺陷)。' },
          { label: '地理', content: '小路、小巷、路口、门口(均为通路开口)、废品收购站。' },
          { label: '静物', content: '破损物、垃圾箱、锅、碗、瓢、盆(皆为开口器物)。' },
          { label: '疾病', content: '受伤、打伤、创伤。' },
        ],
      },
    ],
  },
];